import api from './api';

export interface StatusRfa {
  id: string;
  nome: string;
  codigo: string;
}

export const getAllStatusRfa = () => api.get<StatusRfa[]>('status/rfa');
